<nav class="onderbalk" aria-label="Main">
  <a class="tab" routerLink="/clubs-stats" routerLinkActive="aan" ariaCurrentWhenActive="page">
    <i class="bi bi-camera-video"></i><span>Status</span>
  </a>
  <a class="tab" routerLink="/studio" routerLinkActive="aan" ariaCurrentWhenActive="page">
    <i class="bi bi-broadcast"></i><span>Studios</span>
  </a>
  <a class="tab" routerLink="/numbers" routerLinkActive="aan" ariaCurrentWhenActive="page">
    <i class="bi bi-bar-chart-line"></i><span>Numbers</span>
  </a>
  <a class="tab" *ngIf="superAdmin" routerLink="/club-requests" routerLinkActive="aan" ariaCurrentWhenActive="page">
    <i class="bi bi-inbox"></i><span>Requests</span>
    <em *ngIf="aanvragen() > 0" class="teller">{{ aanvragen() }}</em>
  </a>
  <button type="button" class="tab" [class.aan]="meerOpen" [attr.aria-expanded]="meerOpen" (click)="meerOpen = !meerOpen">
    <i class="bi bi-three-dots"></i><span>More</span>
  </button>
</nav>

<ng-container *ngIf="meerOpen">
  <div class="meer-achter" (click)="meerOpen = false"></div>
  <div class="meer" role="menu">
    <div class="greep"></div>
    <a role="menuitem" *ngIf="superAdmin" routerLink="/account-requests">
      <i class="bi bi-person-plus"></i> Account requests<em *ngIf="accountAanvragen() > 0" class="teller">{{ accountAanvragen() }}</em>
    </a>
    <a role="menuitem" routerLink="/fleet"><i class="bi bi-pc-display"></i> Fleet</a>
    <a role="menuitem" routerLink="/platform-usage"><i class="bi bi-activity"></i> Platform usage</a>
    <a role="menuitem" routerLink="/studio-usage"><i class="bi bi-people"></i> Studio usage</a>
    <a role="menuitem" routerLink="/security"><i class="bi bi-shield-lock"></i> Security</a>
    <p class="noot">Everything else is on a computer.</p>
    <button type="button" role="menuitem" class="uit" (click)="onLogOut()"><i class="bi bi-box-arrow-right"></i> Log out</button>
  </div>
</ng-container>
